export default __webpack_public_path__ + "static/media/pencil-blue.8d0f11b1.svg";